import React from 'react';
import { withTheme, withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import clsx from 'clsx';

// modules
import moment from 'moment';

// ui/ux
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';

const TABLE_STRUCT = [
  {
    name: 'Name',
    id: 'name'
  },
  {
    name: 'Id',
    id: 'scope_id'
  },
  {
    name: '# Users',
    id: 'num_users'
  },
  {
    name: '# Forms',
    id: 'num_forms'
  },
  {
    name: '# Places',
    id: 'num_places'
  },
  {
    name: '# Topics',
    id: 'num_topics'
  },
  {
    name: 'Created',
    id: 'row_created_at'
  },
  {
    name: 'Modified',
    id: 'row_updated_at'
  }
];

const styles = (theme) => ({
  row: {
    cursor: 'pointer'
  },
  gutterBottom: {
    marginBottom: theme.spacing(2)
  },
  loadingCell: {
    padding: 0,
    fontSize: '24px'
  }
});

const progressCharacters = [];
for (let i = 0x25f0; i < 0x25f4; i++) {
  progressCharacters.push(i);
}

class GroupTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      sortOrder: 'asc',
      sortColumn: 'name',
      progressChar: 0
    };

    this.componentDidMount = this.componentDidUpdate;
  }
  valueOrProgress(v) {
    const { loading } = this.props;
    const { progressChar } = this.state;
    if (isNaN(v) && loading) {
      // return <CircularProgress color='secondary' style={{width: 15, height: 15}} />
      // return progressCharacters.map(() => String.fromCharCode(128 * Math.random() + 10240)).join('');
      // https://stackoverflow.com/questions/2685435/cooler-ascii-spinners
      return String.fromCharCode(progressCharacters[progressChar]);
    } else {
      return v || 0;
    }
  }
  componentWillUnmount() {
    if (this._timeout) {
      clearInterval(this._timeout);
      this._timeout = null;
    }
  }
  componentDidUpdate() {
    const { loading } = this.props;
    if (loading && !this._timeout) {
      this._timeout = setInterval(() => {
        const { progressChar } = this.state;
        this.setState({
          progressChar: progressChar >= progressCharacters.length - 1 ? 0 : progressChar + 1
        });
      }, 300);
    } else if (!loading && this._timeout) {
      clearInterval(this._timeout);
      this._timeout = null;
    }
  }
  render() {
    const { classes, scopes, onGroupSelect, filterText, loading } = this.props;
    const { sortOrder, sortColumn } = this.state;
    const filterTextLower = filterText ? filterText.toLowerCase() : null;
    let sortedScopes = scopes.sort((a, b) => {
      a = a[sortColumn];
      b = b[sortColumn];
      if (sortColumn.endsWith('_at')) {
        a = moment(a);
        b = moment(b);
        if (a === b) return 0;
        if (a > b) {
          return sortOrder === 'asc' ? 1 : -1;
        } else {
          return sortOrder === 'asc' ? -1 : 1;
        }
      } else if (typeof a === 'string') {
        return sortOrder === 'asc' ? a.localeCompare(b) : b.localeCompare(a);
      } else if (typeof a === 'number') {
        if (a === b) return 0;
        if (a > b) {
          return sortOrder === 'asc' ? 1 : -1;
        } else {
          return sortOrder === 'asc' ? -1 : 1;
        }
      } else {
        return 0;
      }
    });

    if (filterText && filterText.length > 0) {
      sortedScopes = sortedScopes.filter((d) => {
        return Object.values(d).join(' ').toLowerCase().includes(filterTextLower);
      });
    }
    return (
      <TableContainer className={classes.gutterBottom}>
        <Table className={'noselect'}>
          <TableHead>
            <TableRow>
              {TABLE_STRUCT.map((d) => {
                return (
                  <TableCell align={['num_users', 'num_forms', 'num_places', 'num_topics'].includes(d.id) ? 'center' : 'left'} key={d.id}>
                    <TableSortLabel
                      active={sortColumn === d.id}
                      direction={sortOrder}
                      onClick={() => {
                        if (sortColumn === d.id) {
                          this.setState({ sortOrder: sortOrder === 'asc' ? 'desc' : 'asc' });
                        }
                        this.setState({ sortColumn: d.id });
                      }}
                    >
                      {d.name}
                    </TableSortLabel>
                  </TableCell>
                );
              })}
            </TableRow>
          </TableHead>
          <TableBody>
            {sortedScopes.map((row) => (
              <TableRow
                key={row.scope_id}
                hover
                className={classes.row}
                onClick={() => {
                  onGroupSelect(row);
                }}
              >
                <TableCell align="left" component="th" scope="row">
                  {row.name}
                </TableCell>
                <TableCell align="left">{row.scope_id}</TableCell>

                <TableCell className={clsx({ [classes.loadingCell]: loading && isNaN(row.num_users) })} align="center">
                  {this.valueOrProgress(row.num_users)}
                </TableCell>
                <TableCell className={clsx({ [classes.loadingCell]: loading && isNaN(row.num_forms) })} align="center">
                  {this.valueOrProgress(row.num_forms)}
                </TableCell>
                <TableCell className={clsx({ [classes.loadingCell]: loading && isNaN(row.num_places) })} align="center">
                  {this.valueOrProgress(row.num_places)}
                </TableCell>
                <TableCell className={clsx({ [classes.loadingCell]: loading && isNaN(row.num_topics) })} align="center">
                  {this.valueOrProgress(row.num_topics)}
                </TableCell>

                <TableCell align="left" title={row.row_created_at}>
                  {moment(row.row_created_at).fromNow()}
                </TableCell>
                <TableCell align="left" title={row.row_updated_at}>
                  {moment(row.row_updated_at).fromNow()}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    );
  }
}

GroupTable.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
  scopes: PropTypes.array.isRequired,
  onGroupSelect: PropTypes.func.isRequired,
  filterText: PropTypes.string,
  loading: PropTypes.bool
};
GroupTable.defaultProps = {
  loading: true
};

export default withTheme(withStyles(styles)(GroupTable));
